import { render } from "./TheTopNavigationProfileBtnAdmin.vue?vue&type=template&id=79489bf4&scoped=true"
import script from "./TheTopNavigationProfileBtnAdmin.vue?vue&type=script&lang=js"
export * from "./TheTopNavigationProfileBtnAdmin.vue?vue&type=script&lang=js"

import "./TheTopNavigationProfileBtnAdmin.vue?vue&type=style&index=0&id=79489bf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79489bf4"]])

export default __exports__